//region 1. Platform Libraries
import express from 'express';
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
import DataAPI from '../DataAPI';
//endregion

const context = {
        router: express.Router({ mergeParams: true }),
        cameras: null,
        recorders: null,
        logger: null,
};

context.router.get('/', checkObjectID);
context.router.get('/', checkStreamIndex);
context.router.get('/', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `GET ${req.originalUrl}` });
        log('debug', JSON.stringify(req.params, null, 2));
        const _id = new MongoClient.ObjectID(req.params.id);
        context.cameras.findOne({ _id }, (findOneCameraErr, camera) => {
                if (findOneCameraErr) {
                        log('error', findOneCameraErr.message);
                        res.status(500).send(findOneCameraErr.message);
                        return;
                }
                if (!camera) {
                        const message = 'Camera Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                let triggeredStreams = camera.streams[req.params.index].triggered_streams;
                if (!triggeredStreams) {
                        triggeredStreams = [];
                }
                const expired = new Date(Date.now() - ((DataAPI.heartbeatInterval + 3) * 1000));
                const reply = { recorderInfo: [] };
                triggeredStreams.forEach((triggeredStream, index, array) => {
                        log('debug', JSON.stringify(triggeredStream, null, 2));
                        const triggeredId = triggeredStream.substring(0, 24);
                        const triggeredIndex = triggeredStream.substring(25);
                        context.recorders.findOne({
                                module: 'broker',
                                updated: { $gt: expired },
                        }, { sort: { cpu_load: 1 } }, (findBrokerErr, broker) => {
                                if (findBrokerErr) {
                                        log('error', findBrokerErr.message);
                                        res.status(500).send(findBrokerErr.message);
                                        return;
                                }
                                reply.recorderInfo.push({
                                        host: broker.private_ip,
                                        port: broker.port,
                                        cameraId: triggeredId,
                                        streamIndex: parseInt(triggeredIndex, 10),
                                });
                                if (index === array.length - 1) {
                                        log('debug', JSON.stringify(reply, null, 2));
                                        log('info', '200 OK');
                                        res.status(200).send(reply);
                                }
                        });
                });
        });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/event-recorders
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountEventRecorders(options) {
        context.logger = options.logger;
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountEventRecorders' });
        log('debug', 'Mounting router for /c/:/s/:/event-recorders....');
        options.app.use('/cameras/:id/streams/:index/event-recorders', context.router);
        context.cameras = options.database.collection('cameras');
        context.recorders = options.database.collection('recorders');
        log('info', 'Router for /c/:/s/:/event-recorders Mounted');
}
